/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Skip_Reason_Issued_ElsewhereInputs */

const vi_einvoice_skip_reason_issued_elsewhere = /** @type {(inputs: Einvoice_Skip_Reason_Issued_ElsewhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xuất bằng cách khác`)
};

/**

* @param {Einvoice_Skip_Reason_Issued_ElsewhereInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_skip_reason_issued_elsewhere = /** @type {((inputs?: Einvoice_Skip_Reason_Issued_ElsewhereInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Skip_Reason_Issued_ElsewhereInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_skip_reason_issued_elsewhere(inputs)
});